import React from "react"
import PropTypes from "prop-types"
import Section from "components/Section"
import Typography from "@material-ui/core/Typography"
import { withStyles } from "@material-ui/core/styles"

const styles = theme => ({
	body: {
		display: "flex",
		flexWrap: "wrap",
		marginTop: theme.spacing ( 2 )
	}
})

class IconsSection extends React.Component {

	render () {
		const { classes } = this.props
		return <Section id="icons" >
			<Typography variant="h5" >Icons</Typography>
			<div className={classes.body} >
				<Typography variant="body1" >
					We use Google's Material Design icon font for icons.
					This includes a rich selection of icons that can be used within our design system.
					Another advantage to this icon set is that it is ever evolving.
				</Typography>
			</div>
		</Section>
	}

}

IconsSection.propTypes = {
	classes: PropTypes.object.isRequired
}

export default withStyles ( styles ) ( IconsSection )
